

<div *ngIf="phoneApp">
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">Sealink Inquiry</div>
    </div>
    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                    <div class="lowerCaseLetters" style="font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 3px ">Sealink Number</div>
                    <mat-form-field class="newField" style=" font-size: 17px; min-width: 90%; max-width: 90%; padding: 10px" appearance="outline" >
                      <input [(ngModel)]="sealinkNum" oninput="this.value = this.value.toUpperCase()"  maxlength="11"   matInput>
                      <mat-icon (click)="getSealinkInfo()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>
                    </mat-form-field>
                    <div style="padding-bottom: 15px; padding-top: 5px; text-align: center">
                      <div class="errorDiv2" style="font-size: 15px" *ngIf="noSealink && submitted">Please Input A Sealink Number</div>
                      <div class="errorDiv2" style="font-size: 15px" *ngIf="noSealinkFound && submitted">Sealink Not Found</div>
                    </div>

                  </mat-card>
                </div>

                <div *ngIf="showScreenPhone">
                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="sealink"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px;">Sealink Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Driver Name</mat-label>
                        <input [(ngModel)]="seaLinkDetail.name" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Driver Expiration</mat-label>
                        <input [(ngModel)]="seaLinkDetail.driver_expiration" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Driver Status</mat-label>
                        <input [(ngModel)]="seaLinkDetail.driver_status" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Driver Life Cycle State</mat-label>
                        <input [(ngModel)]="seaLinkDetail.driver_life_cycle_state" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Trucker/Driver Expiration</mat-label>
                        <input [(ngModel)]="seaLinkDetail.trucker_driver_expiration" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Company Code</mat-label>
                        <input [(ngModel)]="seaLinkDetail.id" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Driver/Company Expiration</mat-label>
                        <input [(ngModel)]="seaLinkDetail.driver_company_expiration" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Truck Company Status</mat-label>
                        <input [(ngModel)]="seaLinkDetail.truck_company_status" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Truck Company Life Cycle State</mat-label>
                        <input [(ngModel)]="seaLinkDetail.tc_life_cycle_state" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</div>


<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">

      <mat-card class="details" *ngIf="showScreen">
        <table style="width: 100%; height: 100%">
          <tr>

            <td style="width: 95%;">

              <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
                <tr>
                  <td style="width: 10%" >
                    <div class="maher" (click)="myApp.showCharts()"></div>
                  </td>
                  <td style="width: 70%">
                    <div >
                      <mat-form-field class="search"  appearance="outline">
                        <mat-label style="padding-left: 20px;">Search by Sealink, Driver Name, Expiration Dates</mat-label>
                        <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/sealink.png" ></mat-icon>
                        <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                      </mat-form-field>
                    </div>
                  </td>
                  <td style="width: 20%" *ngIf="ipadApp">
                    <div >
                      <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
                    </div>
                  </td>
                </tr>
              </table>

              <div class="flex-item2" >
                <mat-table #table23 style="width:100%" [dataSource]="sealinkData" multiTemplateDataRows matSort="container"  >

                  <ng-container matColumnDef="card_id" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Sealink</mat-header-cell>
                    <mat-cell  *matCellDef="let row">{{row.card_id}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="name" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Driver Name</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row.name}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="driver_expiration" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{driverExpCol}}</mat-header-cell>
                    <mat-cell  *matCellDef="let row" >{{row.driver_expiration}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="suspended" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Suspended</mat-header-cell>
                    <mat-cell  *matCellDef="let row" >{{row.suspended}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="driver_status" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Driver Status</mat-header-cell>
                    <mat-cell *matCellDef="let row" >{{row.driver_status}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="driver_life_cycle_state" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{drvLifeCycleCol}}</mat-header-cell>
                    <mat-cell  *matCellDef="let row" >{{row.driver_life_cycle_state}}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="driver_company_expiration" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Trucker Exp.</mat-header-cell>
                    <mat-cell *matCellDef="let row" >{{row.driver_company_expiration}}</mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="cColumns; sticky: true"></mat-header-row>
                  <mat-row   *matRowDef="let row; columns: cColumns;" class="table-row"></mat-row>
                </mat-table>
                <mat-toolbar style="width: 100%; display: unset">
                  <mat-toolbar-row style="width: 100%; ">
                    <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                    <span style="padding-left: 24%">
                          <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
                  </span>
                  </mat-toolbar-row>
                </mat-toolbar>
              </div>
            </td>
            <td class="loginPic" style="">

            </td>
          </tr>
        </table>
      </mat-card>


    </td>
    <td class="mainLowerTd">

      <mat-card class="speech-bubble" xmlns="http://www.w3.org/1999/html" *ngIf="ipadAppear" id="noPrint">
        <div class="stacked" style="margin-top: 2%;"></div>
        <div class="titleFont" style="padding-bottom: 10px;">Sealink Inquiry </div>

        <div style="text-align: center">
          <mat-form-field class="myOption2"  appearance="outline" style="min-width: 92%; max-width: 92%">
            <mat-label>{{savedList}}</mat-label>
            <mat-icon matPrefix  style="padding-right: 10px"><img style="vertical-align: center;height:25px; width: 25px" src="assets/sealink.png" ></mat-icon>
            <mat-select  [(value)]="savedList" >
              <mat-option  *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div  style="padding-top: 20px">
            <button mat-raised-button matTooltip="Search for Sealinks" class="blueButton" (click)="getSealinks()">Search</button>
          </div>
        </div>
      </mat-card>

    </td>
  </tr>
</table>


